import { generateUUID } from 'utils/uuid';
import RealizeInput from 'realize/components/input/input';

const Realize = {	
	GridPagination: window.GridPagination,
  i18n: window.Realize.i18n,
};

export default class GridPagination extends Realize.GridPagination {
    renderPerPageCustom() {
        return (
          <div className='per_page'>
            <RealizeInput value={this.props.perPage} component='select'
                   id={"select_paginate_" + generateUUID()}
                   includeBlank={false} clearTheme={true}
                   className='form__input input-field'
                   options={this.props.perPageOptions}
                   onChange={this.changePerPage}
              />
          </div>
        );
      }

      renderRangePaginationCustom() {
        return (
          <div className='range_pagination'>
            <span tabIndex="0">{this.rangePaginationText(Realize.i18n.t('from'))}</span>
          </div>
        );
      }

      render() {
        return (
          <div className={this.className()}>
            {this.renderPagination()}
            {this.renderRangePaginationCustom()}
            {this.renderPerPageCustom()}
          </div>
        );
      }
}
